export const REQUEST_QUOTATIONS = {
  GET_REQUEST_QUOTATIONS_LIST: "get_quotations_list",
  REQUEST_QUOTATIONS_LIST_SUCCESS: "quotations_list_success",
  DELETE_QUOTATIONS_FROM_LIST: "delete_quotations_from_list",
  DELETE_QUOTATIONS_FROM_LIST_SUCCESS: "delete_quotations_from_list_success",
  GET_SEARCH_QUOTATIONS_FROM_LIST: "get_search_quotations_from_list",
  SEARCH_PRODUCTS_QUOTATIONS_FROM_LIST_SUCCESS:
    "search_quotations_from_list_success",
  GET_MESSAGES: "get_messages",
  GET_MESSAGES_SUCCESS: "get_messages_success",
  GET_SEARCH_QUOTATIONS_FROM_LIST_WITH_EMAIL_ID:"get_search_quotations_from_list_with_email_id",
  GET_FREIGHT_RATE_RFQS_SUCCESS: 'get_freight_rate_rfqs_success',
  GET_CHA_RFQS_SUCCESS: 'get_cha_rfqs_success',
  GET_MANUFACTURER_RFQS_SUCCESS: 'get_manufacturer_rfqs_success',
  GET_FREIGHT_RATE_RFQS: 'get_freight_rate_rfqs',
  GET_CHA_RFQS: 'get_cha_rfqs',
  GET_MANUFACTURER_RFQS: 'get_manufacturer_rfqs'
};
